import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import businessManagement from "../../../assets/images/plmimplementationimage/business-process-change-management.jpg";

const SolutionOverview = () => {
  const imgRef = useRef(null);

  // --- PARALLAX SCROLL ---
  useEffect(() => {
    const onScroll = () => {
      const offset = window.scrollY * 0.1;
      if (imgRef.current) {
        imgRef.current.style.transform = `translateY(${offset}px)`;
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Wrapper>
      <ParticleLayer />
      <GridOverlay />

      <Container>

        {/* LEFT SIDE CONTENT */}
        <motion.div
          initial={{ opacity: 0, y: 80 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <SectionTitle>About Us</SectionTitle>
          <Heading>Overview</Heading>
          <Text>
            NexTech helps your business implement business workflows, change
            management processes, and Issue Management & CAPA solutions using
            best practices…
          </Text>
        </motion.div>

        {/* RIGHT SIDE IMAGE (PARALLAX + GLOW) */}
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <ImageWrapper ref={imgRef}>
            <img src={businessManagement} alt="Business" />
          </ImageWrapper>
        </motion.div>

      </Container>
    </Wrapper>
  );
};

export default SolutionOverview;



// -------------------- STYLES --------------------

const Wrapper = styled.section`
  position: relative;
  padding: 120px 0;
  background: #f5f8fb;
  overflow: hidden;
`;

/* ⭐ FAKE PARTICLE EFFECT (PURE CSS) */
const ParticleLayer = styled.div`
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(2px 2px at 20px 30px, #00eaff 70%, transparent 0),
    radial-gradient(2px 2px at 80px 120px, #00eaff 70%, transparent 0),
    radial-gradient(2px 2px at 200px 200px, #00eaff 70%, transparent 0),
    radial-gradient(2px 2px at 300px 80px, #00eaff 70%, transparent 0),
    radial-gradient(2px 2px at 500px 60px, #00eaff 70%, transparent 0);
  background-size: 600px 600px;
  opacity: 0.4;
  animation: floatParticles 18s linear infinite;
  z-index: 1;

  @keyframes floatParticles {
    from { transform: translateY(0); }
    to { transform: translateY(-300px); }
  }
`;

/* ⭐ TECH GRID ANIMATION */
const GridOverlay = styled.div`
  position: absolute;
  inset: 0;
  background-image: 
    linear-gradient(rgba(0, 150, 255, 0.10) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 150, 255, 0.10) 1px, transparent 1px);
  background-size: 55px 55px;
  animation: gridMove 14s linear infinite;
  opacity: 0.35;
  z-index: 1;

  @keyframes gridMove {
    from { transform: translateY(0); }
    to { transform: translateY(-55px); }
  }
`;

const Container = styled.div`
  width: 85%;
  margin: auto;
  display: flex;
  gap: 60px;
  position: relative;
  z-index: 5;

  @media (max-width: 900px) {
    flex-direction: column;
    text-align: center;
  }
`;

const SectionTitle = styled.h4`
  color: #00bfff;
  font-size: 1rem;
  font-weight: 700;
`;

const Heading = styled.h2`
  font-size: 2.8rem;
  font-weight: 700;
  color: #06334b;
`;

const Text = styled.p`
  font-size: 1rem;
  color: #666;
  margin-top: 20px;
  line-height: 1.8;
  max-width: 600px;
`;

const ImageWrapper = styled.div`
  width: 480px;
  border-radius: 14px;
  overflow: hidden;
  position: relative;
  border: 2px solid rgba(0, 225, 255, 0.5);
  box-shadow: 0 0 25px rgba(0, 225, 255, 0.4);
  transition: 0.3s ease;

  img {
    width: 100%;
    display: block;
  }

  &:hover {
    box-shadow: 0 0 35px rgba(0, 225, 255, 0.7);
    transform: scale(1.02);
  }

  @media (max-width: 900px) {
    margin: auto;
    width: 90%;
  }
`;
